import { Tasks } from '../Tasks';
import { CreateTask } from '../pages';
import { RouteObject } from 'react-router-dom';

export const TasksRoutes: RouteObject[] = [
  {
    path: '',
    element: <Tasks />,
  },
  {
    path: 'create',
    element: <CreateTask />,
  },
];
